import { SVGProps } from 'react';

export const Search = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.74273 17.0498C7.79175 17.0498 5.95646 16.2898 4.57665 14.91C3.19562 13.5302 2.43568 11.6949 2.43568 9.74273C2.43568 7.79175 3.19562 5.95646 4.57665 4.57665C5.95646 3.19562 7.79175 2.43568 9.74273 2.43568C11.6937 2.43568 13.529 3.19562 14.9088 4.57665C16.2898 5.95646 17.0498 7.79175 17.0498 9.74273C17.0498 11.6949 16.2898 13.5302 14.9088 14.91C13.529 16.2898 11.6937 17.0498 9.74273 17.0498ZM24 22.278L17.4334 15.7102C18.7584 14.01 19.4855 11.9336 19.4855 9.74273C19.4855 7.1402 18.471 4.69356 16.6308 2.85462C14.7919 1.01324 12.3453 0 9.74273 0C7.1402 0 4.69356 1.01324 2.85462 2.85462C1.01446 4.69356 0 7.1402 0 9.74273C0 12.3453 1.01446 14.7919 2.85462 16.6308C4.69356 18.4722 7.1402 19.4855 9.74273 19.4855C11.9336 19.4855 14.01 18.7596 15.7102 17.4322L22.278 24L24 22.278Z"
      fill="currentColor"
    />
  </svg>
);
